import { render } from "./StaticRoutesTab.vue?vue&type=template&id=2c15dd27&scoped=true"
import script from "./StaticRoutesTab.vue?vue&type=script&lang=js"
export * from "./StaticRoutesTab.vue?vue&type=script&lang=js"

import "./StaticRoutesTab.vue?vue&type=style&index=0&id=2c15dd27&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c15dd27"]])

export default __exports__